import FormGroup from "./FormGroup";
import PhoneInput from "react-phone-input-2";
import {Link, useNavigate} from "react-router-dom";
import React from "react";
import {sendRequest} from "../services/Sender";
import Loader from "./Loader";
import {useDispatch, connect} from "react-redux";
import {userLogin} from "../actions/user";
import {userService} from "../services/UserService";
import withRouter from "./WithRouter";
import {ClientService} from "../services/ClientService";


class LoginForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            password: '',

            btnClass: '',
            errors: {
                phone: false,
                password: false
            }
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.phoneChange = this.phoneChange.bind(this);


    }


    handleChange(event) {
        this.setState({password: event.target.value});
    }

    phoneChange(phone) {
        this.setState({phone: phone});
    }

    handleSubmit(event) {
        this.setState({
            btnClass: 'disabled'
        })
        
        // Use new JWT authentication
        fetch('/api/v1/auth/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `username=${encodeURIComponent(this.state.phone)}&password=${encodeURIComponent(this.state.password)}`
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return response.json().then(err => {
                    throw new Error(err.detail || 'Login failed');
                }).catch(() => {
                    throw new Error('Login failed');
                });
            }
        }).then(data => {
            // Store JWT token
            localStorage.setItem('access_token', data.access_token);
            
            // Get user info
            return fetch('/api/v1/auth/me', {
                headers: {
                    'Authorization': `Bearer ${data.access_token}`
                }
            });
        }).then(response => {
            if (!response.ok) {
                throw new Error('Failed to get user info');
            }
            return response.json();
        })
        .then(userInfo => {
            if (!userInfo || !userInfo.id) {
                throw new Error('Invalid user info');
            }
            
            let d = {
                id: userInfo.id,
                accessToken: localStorage.getItem('access_token'),
                client_id: 1
            }

            this.props.userLogin(d);
            userService.Auth(d.accessToken);

            ClientService.GetList().then((rows) => {
                if (rows && rows.items && rows.items.length > 0) {
                    userService.SetCurrentDepartment(rows.items[0].id)
                    // полная перезагрузка: store читает отдел из localStorage только при старте
                    window.location.href = '/';
                } else {
                    console.error('No clients found');
                    this.setState({
                        btnClass: '',
                        errors: {
                            password: 'Ошибка загрузки данных'
                        }
                    });
                }
            }).catch(error => {
                console.error('Error loading clients:', error);
                this.setState({
                    btnClass: '',
                    errors: {
                        password: 'Ошибка загрузки данных'
                    }
                });
            });
        }).catch(error => {
            console.error('Login error:', error);
            this.setState({
                btnClass: '',
                errors: {
                    password: 'Неверный телефон или пароль'
                }
            });
        });
        
        event.preventDefault();
    }


    render() {


        return (
            <form className={"theme-form login-form"} onSubmit={this.handleSubmit}>
                <h2>Войдите в систему</h2>
                <h6>Введите номер телефона и пароль</h6>

                <FormGroup label={"Телефон"} icon={'user'} error={this.state.errors.phone}>
                    <PhoneInput specialLabel={false} value={this.state.phone} country={'ru'} inputClass={'form-control'}
                                onChange={this.phoneChange} inputProps={{required: true}}/>
                </FormGroup>

                <FormGroup label={"Пароль"} icon={'lock'} error={this.state.errors.password}>
                    <input type="password" placeholder={'******'} value={this.state.password}
                           onChange={this.handleChange} className={'form-control'} required={'required'}/>
                </FormGroup>



                <div className="form-group">
                    <button className={"btn btn-primary btn-block " + this.state.btnClass} type="submit">Войти</button>
                </div>

                {this.state.errors.password && <>
                    <div className="alert alert-danger dark" role="alert">
                        <p>{this.state.errors.password}</p>
                    </div>
                </>}


            </form>
        )
    }

}

export default connect(
    null,
    {userLogin}
)(withRouter(LoginForm));